<template>
  <el-card  :header="$t('routes.createroutes')" style="width:400px">
    <el-form
      ref="form"
      data-v-step="routeFrom"
      :label-width="'200px'"
      :inline="false"
      label-position="top"
      :rules="rules"
      :model="form"
      :span="12"
    >
      <el-form-item :label="$t('routes.name')" prop="name">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item prop="points">
        <slot name="label">{{$t('home.tree')}}</slot>
        <br />

        <el-tree
          ref="tree"
          :data="tree"
          default-expand-all
          node-key="_id"
          :props="options"
          :filter-node-method="filterNode"
          highlight-current
          :expand-on-click-node="false"
          :empty-text="$t('common.selectPointsFromLeftTree')"
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <span>
              <span v-if="node.data.nodeType =='point'">
                <em class="fas fa-crosshairs"></em>
                {{node.data.name}}
              </span>
              <span v-if="node.data.nodeType =='group'">{{node.data.name}}</span>
            </span>
          </span>
        </el-tree>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="save()">{{$t('common.create')}}</el-button>
        <el-button @click="cancel()">{{$t('common.cancel')}}</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";
export default {
  name: "CreateRoute",
  events: ["created", "cancelled"],
  data() {
    return {
      options: {
        label: "name",
        children: "children",
        checkbox: false,
      },
      form: {
        name: "",
        points: [],
      },
      rules: {
        name: [
          { required: true, message: this.$t('point.inputName'), trigger: "blur" },
        ],
        points: [
          {
            type: "array",
            required: true,
            message: this.$t('common.leastOnePoint'),
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {},
  mounted() {
    this.$bus.emit("selectNodes", []);
  },
  watch: {
    checkedNodes() {
      this.form.points = this.activePoints;
      this.$refs.tree.filter();
    },
  },
  computed: {
    ...mapState("tree", ["tree", "checkedNodes", "activePoints"]),
  },
  methods: {
    ...mapActions("route", ["createRoute"]),
    filterNode(value, data) {
      return this.checkedNodes.map((x) => x._id).includes(data._id);
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.createRoute({
            name: this.form.name,
            points: this.activePoints,
          }).then(() => {
            this.$emit("created");
          });
        } else {
          return false;
        }
      });
    },
    cancel() {
      this.$emit("cancelled");
    },
  },
};
</script>

<style>
.el-card__body {
  word-break: break-word !important;
}
</style>